export const mapboxAccessToken = 'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjbWF2azZwa3YwNWlrMmxteXgxNHU1dzI2In0.-huSfvRrNbM-QysmBKrcFA';
export const boundingBox = [-124.409180, 32.147130, -114.082031, 42.090580];

// Data service
const buckets = {
    test: 'caltimes-wildfires-map-geoprocessor-dev',
    dev: 'caltimes-wildfires-map-geoprocessor-dev',
    prod: 'caltimes-wildfires-map-geoprocessor-prod'
}
export const cdnUrl = `https://${buckets[process.env.BAKER_BUILD_ENV]}.s3.us-west-2.amazonaws.com/combined/latest.topojson`;
